class ProductDetailContent extends HTMLElement {
  /** @type {HTMLElement | null} */
  #productDetails = null;

  connectedCallback() {
    const productDetails = this.closest('.product-details');
    if (!(productDetails instanceof HTMLElement)) return;

    if (this.#productDetails !== productDetails) {
      this.#productDetails?.removeEventListener('click', this.#handleClick);
      this.#productDetails = productDetails;
    }

    productDetails.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.#productDetails?.removeEventListener('click', this.#handleClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const dialog = this.#productDetails?.querySelector('[data-size-guide-dialog]');
    if (!(dialog instanceof HTMLDialogElement)) return;

    if (event.target.closest('[data-size-guide-trigger]')) {
      if (!dialog.open) dialog.showModal();
      return;
    }

    if (event.target.closest('[data-size-guide-close]') || event.target === dialog) {
      if (dialog.open) dialog.close();
    }
  };
}

if (!customElements.get('product-detail-content')) {
  customElements.define('product-detail-content', ProductDetailContent);
}
